import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import LeadSquaredReaderForm from '../forms/lead-squared-reader-form';
import { leadSquaredReaderValidationSchema } from '../schema/leadSquaredReader.js';

export default function LeadSquaredReaderNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'LeadSquared Reader Node Details',
        altText: 'LeadSquared Reader Node',
        defaultLabel: 'LeadSquared Reader Node',
      }}
    >
      <CommonNode
        FormComponent={LeadSquaredReaderForm}
        schemaResolver={leadSquaredReaderValidationSchema}
      />
    </NodeProvider>
  );
}
